import { SiGitconnected } from "react-icons/si";
import { DemoTemplatesViewerMain } from "../DemoTemplatesViewerMain.js";

export const DemoTemplatesViewerModule = (DATA_USER_AUTH = null, lang = "es") => [
    {
        views: "PUBLIC", path: "/templates-demo", component: <DemoTemplatesViewerMain />,
        roles: null, permissions: null, label: "Templates UI", icon: <SiGitconnected />,
        displayInHeader: true, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
    {
        views: "PUBLIC", path: "/templates-demo/:templateId", component: <DemoTemplatesViewerMain />,
        roles: null, permissions: null, label: "Templates UI", icon: null,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isHiddenFromNavigation: true, isBlockedWhenLogged: false,
    },
];
